















import { Component } from 'vue-property-decorator';
import Stars from '../../ScoreInput/Stars.vue';
import ClassEES from './ClassEES';

@Component({ components: { Stars } })
export default class ClassEES7Star  extends ClassEES {}
